import { useEffect, useState, useCallback } from "react";
import { readCart, cartTotals } from "../lib/cart";

export const useCart = () => {
  const [items, setItems] = useState(() => readCart());

  const refresh = useCallback(() => setItems(readCart()), []);

  useEffect(() => {
    const handler = () => refresh();
    window.addEventListener("tjb-cart-change", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("tjb-cart-change", handler);
      window.removeEventListener("storage", handler);
    };
  }, [refresh]);

  const totals = cartTotals(items);
  return { items, count: totals.count, total: totals.total, refresh };
};
